import { render, staticRenderFns } from "./address-select.vue?vue&type=template&id=08e966c0"
import script from "./address-select.vue?vue&type=script&lang=ts"
export * from "./address-select.vue?vue&type=script&lang=ts"
import style0 from "./address-select.vue?vue&type=style&index=0&id=08e966c0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08e966c0')) {
      api.createRecord('08e966c0', component.options)
    } else {
      api.reload('08e966c0', component.options)
    }
    module.hot.accept("./address-select.vue?vue&type=template&id=08e966c0", function () {
      api.rerender('08e966c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/address-select.vue"
export default component.exports